export { default as RegistryProxyMixin } from './lib/mixins/registry_proxy';
export { default as ContainerProxyMixin } from './lib/mixins/container_proxy';
export { default as Comparable } from './lib/mixins/comparable';
export { default as ActionHandler } from './lib/mixins/action_handler';
export { default as _ProxyMixin, contentFor as _contentFor } from './lib/mixins/-proxy';
export { default as MutableEnumerable } from '@ember/enumerable/mutable';
export { default as TargetActionSupport } from './lib/mixins/target_action_support';

export { default as RSVP, onerrorDefault } from './lib/ext/rsvp'; // just for side effect of extending Ember.RSVP
